export default "__VITE_ASSET__CdeUCSJc__"